module.exports = __webpack_public_path__ + "img/footprint.01107cb8.jpg";